import Layout from '../../internal/Layout.vue'
import InstitutionPage from './institutions/institutions.vue'
import ChangeInstitution from './components/changeInstitution/changeInstitution.vue'

const InstitutionRoutes = {
  component: Layout,
  children: [
    {
      name: 'institution',
      path: '/',
      component: InstitutionPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresSupervisor: true,
        requiresAdmin: true,
      },
    },
    {
      name: 'changeInstitution',
      path: '/changeInstitution',
      component: ChangeInstitution,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default InstitutionRoutes
